<template>
    <el-dialog class="editor-dialog" title='供应商管理' :visible.sync="visible" append-to-body :show-close="true" width="40%" top="6vh">
        <el-form label-width="100px" :model="model" :rules="rules" ref="model" @submit.native.prevent="submitForm('model')">
          <el-form-item label="模型平台" prop="cloudPlatform">
            <el-select
              v-model="model.cloudPlatform"
              :style="formLabelWidth"
              placeholder="请选择模型平台">
              <el-option
                v-for="item in [{label:'千问通义',value:'qwen'},{label:'月之暗面',value:'kimi'}]"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="apiKey" prop="apiKey">
            <el-input v-model="model.apiKey" placeholder="请填写apiKey" :style="formLabelWidth"></el-input>
          </el-form-item>
          <el-form-item label="baseURL" prop="baseURL">
            <el-input v-model="model.baseURL" placeholder="请填写baseURL" :style="formLabelWidth"></el-input>
          </el-form-item>
          <el-form-item label="PlatformURL">
            <el-input v-model="model.PlatformURL" placeholder="请填写PlatformURL" :style="formLabelWidth"></el-input>
          </el-form-item>
          <el-form-item label="启用">
            <el-radio-group v-model="model.isEnable" size="small">
              <el-radio-button :label='true'>是</el-radio-button>
              <el-radio-button :label='false'>否</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <div style="text-align: center;margin: 15px;width: 100%;">
            <el-button type="primary" size="small" native-type="submit">提交</el-button>
            <el-button type="danger" size="small" @click="cancelSubmit">取消</el-button>
          </div>
        </el-form>
    </el-dialog>
</template>
<script>
import http from '@/http'
export default {
  data() {
    return {
      visible: false,
      formLabelWidth: { width: "95%" },
      itemID:null,
      model:{
        isEnable:true
      },
      isCreateNew:true,
      rules: {
        cloudPlatform: [
          { required: true,  message: '请选择模型平台', trigger: 'blur' },
        ],
        apiKey: [
          { required: true,  message: '请填写apiKey', trigger: 'blur' },
        ],
        baseURL: [
          { required: true,  message: '请填写baseURL', trigger: 'blur' },
        ]
      }
    };
  },
  methods:{
    //提交验证表单数据
    submitForm(model) {
      this.$refs[model].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          this.$message.error('未提交成功，表单填写不完整');
          return false;
        }
      });
    },
    async save(){
      if(this.isCreateNew){
          await http.post(`/setting/systemInfo/openai/${this.itemID}`,this.model)
          this.$message({
              type: "success",
              message: '创建成功',
          })
        }else{
          await http.put(`/setting/systemInfo/openai/${this.itemID}`,this.model)
          this.$message({
              type: "success",
              message: '更新成功',
          });
        }
      this.visible = false;
      this.callback()
    },
    cancelSubmit() {
      document.body.removeChild(this.$el);
      this.visible = false;
    },
  }
  };
</script>
<style scoped>
.editor-dialog>>>.el-dialog__header {
  text-align: center !important;
}
.editor-dialog>>>.el-dialog__title {
  font-weight: 700 !important;
}
.el-form-item{
  margin-bottom: 13px!important;
  width: 100%;
}
</style>
